import { gql } from '@apollo/client';

export const GET_LIST_REFINERS = gql`
  query GetList($where: Map, $sort: Map, $limit: Int, $offset: Int) {
    GetRefinerList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Refiners {
        data {
          id
          name
          team_id
          created_by_id
          created_by {
            ... on User {
              name
              email
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  object_name
                  bucket_name
                }
              }
            }
          }
          deleted_at
          updated_at
          created_at
        }
      }
    }
  }
`;

export const GET_LIST_REFINERS_NOTES = gql`
  query GetList($where: Map, $sort: Map, $limit: Int, $offset: Int) {
    GetRefinerNoteList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on RefinerNotes {
        data {
          id
          name
          content
          user_id
          user {
            ... on User {
              name
              id
            }
          }
          refiner_id
          refiner {
            ... on Refiner {
              name
            }
          }
          deleted_at
          updated_at
          created_at
        }
      }
    }
  }
`;

export const GET_REFINER_ID = gql`
  query GetByID($id: String!) {
    list: GetRefinerByID(id: $id) {
      id
      name
      created_by_id
      created_by {
        ... on User {
          name
        }
      }
      refiner_ad_analyzers {
        ... on RefinerAdAnalyzers {
          data {
            refiner_id
            ad_analyzer_id
            ad_analyzer {
              ... on AdAnalyzer {
                id
                name
                created_by
                created_at
                deleted_at
                analyzer_integrations {
                  ... on AnalyzerIntegrations {
                    data {
                      id
                      type
                      ad_insight
                    }
                  }
                }
                ad_integrations {
                  ... on PaginationResponse {
                    count
                  }
                  ... on AdIntegrations {
                    data {
                      id
                      currency
                      user_socmed_id
                      user_socmed {
                        ... on SocmedAccount {
                          id
                          team_id
                          type
                          username
                          url
                          account_token
                          active_status
                          ad_account_id
                        }
                      }
                      type
                      ad {
                        ... on Ad {
                          id
                          ad_set_id
                          ad_set {
                            ... on AdSet {
                              campaign_id
                              campaign {
                                ... on Campaign {
                                  id
                                  name
                                  budget
                                  start_date
                                  end_date
                                }
                              }
                              team_id
                              name
                              start_date
                              end_date
                              budget
                              created_at
                              updated_at
                              deleted_at
                            }
                          }
                          name
                          start_date
                          end_date
                          budget
                          headline
                          offer
                          product_name
                          sku
                          upc_user
                          content
                          created_at
                          updated_at
                          deleted_at
                        }
                      }
                      socmed_ad_local
                      socmed_ad_id
                      socmed_adset_id
                      document_ids
                      documents {
                        ... on Document {
                          id
                          name
                          url_link
                          object_name
                          bucket_name
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      deleted_at
      updated_at
      created_at
    }
  }
`;
